import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  fetchConfigBankData,
  fetchConfigBankAlert,
  downloadConfigBankTable,
  fetchOrderDaysFF,
} from './configBankThunk'

export interface ConfigBankStateType {
  isLoading: boolean
  isShimmerLoading: boolean
  query: {
    [key: string]: string
  }
  isInvalid: boolean
  orderDaysFF: boolean
}

const initialState: ConfigBankStateType = {
  isLoading: false,
  isShimmerLoading: false,
  query: {},
  isInvalid: false,
  orderDaysFF: false,
}

export const sliceName = 'configBank'

const configBankSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    reset: () => initialState,
    setQuery: (state, action: PayloadAction<{ [key: string]: string }>) => {
      state.query = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfigBankData.pending, (state) => {
        state.isShimmerLoading = true
      })
      .addCase(fetchConfigBankData.fulfilled, (state) => {
        state.isShimmerLoading = false
      })
      .addCase(fetchConfigBankData.rejected, (state) => {
        state.isShimmerLoading = false
      })
      .addCase(fetchConfigBankAlert.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchConfigBankAlert.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.isInvalid = payload.data.is_data_invalid
      })
      .addCase(fetchConfigBankAlert.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(downloadConfigBankTable.pending, (state) => {
        state.isLoading = true
      })
      .addCase(downloadConfigBankTable.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(downloadConfigBankTable.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(fetchOrderDaysFF.fulfilled, (state, { payload }) => {
        state.orderDaysFF = payload.data.FF_ENABLE_SCMS_ORDER_DAYS === 'true'
      })
  },
})

export const { reset, setQuery } = configBankSlice.actions

export default configBankSlice.reducer
